import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { ResponseData } from '../model/response.model';
import { LoaderService } from '../loader.service';
import { retry, catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})

export class HttpService {

  $result: Observable<any>;
  weather: any;

  constructor(private http: HttpClient, public loaderService: LoaderService) { }

  public createContentHeader(headers: Headers) {
    headers.append("Content-Type", "application/json");
  }

  public get(url: string, param: any = null): Observable<ResponseData> {
    this.loaderService.show();
    return this.http.get<ResponseData>(url, { params: param })
      .pipe(
        map((response: ResponseData) => {
          this.loaderService.hide();
          return response;
        }),

        catchError(this.handleError))
  }


  handleError(error) {
    // this.loaderService.hide();
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }

    // window.alert(errorMessage);
    return throwError(errorMessage);
  }




  public getStatic(url: string): any {
    // this.loaderService.show();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    return this.http.get(url, httpOptions).pipe(
      map((response: any) => {
        // this.loaderService.hide();
        return response
      }, err => {
        // this.loaderService.hide();
      }));
  }

  public post(url: string, params: any = null, oldModel: any = null): Observable<ResponseData> {

    // this.loaderService.show();
    return this.http.post(url, params).pipe(map((response: ResponseData) => {
      if (response != null) {
        // this.loaderService.hide();
        return response
      }
      else {
        throw new Error('Valid token not returned');
      }
    }, err => {
      // this.loaderService.hide();
    }));
  }


}
